var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKeyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.57 46.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b3866;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.57,21.42c0-1.81-.6-2.49-2.34-2.49H48.66A23.3,23.3,0,1,0,49,36.44H60.86c2.55,0,3.65.68,3.65,3,0,1,0,2.52,0,3.51,0,1.89.78,3.4,3.13,3.4H77.75c1.39,0,1.76.22,1.76-3.25,0-2.39.07-5.83.07-8.27l6,0c1.66,0,2.39,1.27,2.39,3.78,0,2.06,0,4.81,0,7,0,2.55.36,4.53,2.48,4.53h11.56a1.54,1.54,0,0,0,1.47-1.66C103.58,46.09,103.58,28.1,103.57,21.42Zm-76.3,14.7a8,8,0,1,1,8.05-8A8.07,8.07,0,0,1,27.27,36.12Z",
    transform: "translate(-4 -4.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKeyBlue);
export default __webpack_public_path__ + "static/media/logo_key_blue.d9e6e163b3ec08076ab91ef1c1e079da.svg";
export { ForwardRef as ReactComponent };